import { useTranslation } from 'react-i18next';
import { DeliveryMethod } from '~/graphql/graphql';
import {
  DELIVERY_METHOD_ORDER,
  deliveryMethodLabelKey,
  deliveryMethodTestId,
} from '~/utils/deliveryMethod';

interface DeliveryMethodSelectorProps {
  value: DeliveryMethod | null;
  onChange: (method: DeliveryMethod) => void;
}

export function DeliveryMethodSelector({
  value,
  onChange,
}: Readonly<DeliveryMethodSelectorProps>) {
  const { t } = useTranslation('cart');
  const selectedIndex = value ? DELIVERY_METHOD_ORDER.indexOf(value) : -1;

  return (
    <div
      data-testid="delivery-method-selector"
      className="relative grid grid-cols-4 bg-neut-100 rounded-lg p-1"
    >
      {selectedIndex >= 0 && (
        <div
          aria-hidden="true"
          className="absolute top-1 bottom-1 left-[2px] rounded-md bg-prim-500 transition-transform duration-200 ease-out"
          style={{
            width: 'calc(25% - 4px)',
            transform: `translateX(calc(${selectedIndex * 100}% + ${selectedIndex * 4}px))`,
          }}
        />
      )}
      {DELIVERY_METHOD_ORDER.map((method) => {
        const isSelected = method === value;
        return (
          <button
            key={method}
            type="button"
            data-testid={deliveryMethodTestId(method)}
            aria-pressed={isSelected}
            onClick={() => onChange(method)}
            className={`relative z-10 py-1.5 px-0.5 text-[10px] leading-tight font-medium rounded-md transition-colors ${
              isSelected ? 'text-neut-0' : 'text-neut-600 hover:text-neut-900'
            }`}
          >
            {t(deliveryMethodLabelKey(method))}
          </button>
        );
      })}
    </div>
  );
}
